// src/sectors/pilates/members/components/paymentReceive/ui.js
import { alpha } from '@mui/material/styles';

export function moneyTRY(n) {
  if (typeof n !== 'number' || !Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('tr-TR').format(n) + ' ₺';
}

export function numOr0(x) {
  if (x === '' || x == null) return 0;
  const n = Number(String(x).replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
}
export function money(n) {
  if (typeof n !== 'number' || !Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('tr-TR').format(Math.round(n)) + ' ₺';
}

export function buildPaymentStyles(theme) {
  // ✅ sadece renk kaynağı değişti
  // Kartlar: mavimsi (info)
  const accent = theme.palette.info.main;

  // Header: turuncu kalsın (istersen bunu da mavi yaparız)
  const orange = theme.palette.warning.main;

  const accentSoft = alpha(accent, 0.05);
  const accentSoft2 = alpha(accent, 0.18);

  const headerSx = {
    pb: 1,
    background: `linear-gradient(135deg, ${alpha(orange, 0.22)}, ${alpha(
      theme.palette.background.paper,
      0
    )})`,
  };

  // ✅ card artık turuncu değil, mavimsi
  const cardSx = {
    p: 1.5,
    borderRadius: '18px',
    border: `1px solid ${alpha(accent, 0.28)}`,
    background: `linear-gradient(135deg, ${accentSoft}, ${alpha(
      theme.palette.background.paper,
      0.8
    )})`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.5,
    transition: 'all 180ms ease',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: `0 10px 26px ${alpha(orange, 0.22)}`,
      borderColor: alpha(orange, 0.45),
      background: `linear-gradient(135deg, ${accentSoft2}, ${alpha(
        theme.palette.background.paper,
        0.9
      )})`,
    },
    '&:active': { transform: 'translateY(0px)' },
  };

  // ✅ icon badge artık turuncu değil, mavimsi
  const iconBadgeSx = {
    width: 44,
    height: 44,
    borderRadius: '14px',
    display: 'grid',
    placeItems: 'center',
    background: `linear-gradient(135deg, ${alpha(orange, 0.26)}, ${alpha(accent, 0.06)})`,
    border: `1px solid ${alpha(orange, 0.25)}`,
    flex: '0 0 auto',
  };

  // ✅ chip artık turuncu değil, mavimsi
  const chipSx = {
    borderRadius: '999px',
    background: alpha(orange, 0.12),
    border: `1px solid ${alpha(orange, 0.25)}`,
  };

  // dışarıya accent’i de verelim (ikon renklerinde kullanırsın)
  return { orange, accent, headerSx, cardSx, iconBadgeSx, chipSx };
}
